import { ClientType } from "../../../common/enums";

export const CLIENT_TYPE_ROUTES: Record<ClientType, string[]> = {
    [ClientType.SelfServe]: ["/products", "/messages", "/analytics", "/payouts", "/stores", "/new-user", "/logout", "/settings"],
    [ClientType.Partnership]: ["/analytics", "/payouts", "/logout", "/settings"],
    [ClientType.Unset]: ["/new-user", "/logout", "/settings"],
};
